import { Stack, Typography } from "@mui/material";
import {
  getRiskScoreClassification,
  getRiskScoreClassificationShortName,
  riskAssessmentColors,
} from "../utils/riskAssessments";

import DetailCell from "./DetailCell";
import { RiskAssessmentData } from "../features/data/patientApiSlice";
import { createStyleSheet } from "../utils/styles";
import { formatDistanceToNowInDays } from "../utils/dates";
import { useTranslation } from "react-i18next";

const SingleRiskAssessmentCell = (props: {
  riskAssessment: RiskAssessmentData;
  first?: boolean;
}) => {
  const { riskAssessment, first } = props;
  const { t } = useTranslation("Patient");
  return (
    <DetailCell
      title={t(
        `riskAssessmentTypes:${riskAssessment?.type || "unknown"}:title`
      )}
      subTitle={
        riskAssessment?.timestamp
          ? t("calculatedTime", {
              time: formatDistanceToNowInDays(
                new Date(riskAssessment.timestamp)
              ),
            })
          : t("common:unknown")
      }
      first={first}
    >
      <Stack direction={"row"}>
        <Typography
          variant="detailCellBody"
          sx={{
            color:
              riskAssessmentColors[
                getRiskScoreClassification(riskAssessment)
              ],
          }}
        >
          {getRiskScoreClassificationShortName(t, riskAssessment)}
        </Typography>
        {riskAssessment?.confidence_score_classification ? (
          <Typography variant="detailCellBody" sx={styles.confidenceText}>
            &nbsp;|&nbsp;
            {`${t(
              "confidenceScoreClassifications:" +
                riskAssessment.confidence_score_classification
            )}`}
          </Typography>
        ) : null}
      </Stack>
    </DetailCell>
  );
};

const styles = createStyleSheet({
  confidenceText: {
    display: "inline",
  },
});

export default SingleRiskAssessmentCell;
